import React from "react"
import PropTypes from "prop-types"
import mount from "core/mount"
import { Link } from "core/link"
import Icon from "@kit/design/icon"

const BackBtn = ({ label, href }) => {
  return (
    <Link
      href={href}
      className="w-10 rounded border border-solid border-transparent mr-2 md:my-3 hover:bg-gray-50 focus:outline-blue focus:bg-gray-50"
      style={{ padding: 7 }}
    >
      <Icon name="arrow-left" label={label} />
    </Link>
  )
}

BackBtn.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string
}

mount({ BackBtn })
export default BackBtn
